import { render, staticRenderFns } from "./NewResourceItem.vue?vue&type=template&id=c81cbc42"
import script from "./NewResourceItem.vue?vue&type=script&lang=js"
export * from "./NewResourceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports